import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import type { Category } from "@/types";
import { ArrowRight } from "lucide-react";

// Card for the "Shop by Condition" homepage section (frame 22:2).
export function ConditionCard({ category }: { category: Category }) {
  const Icon = (category.icon &&
    (Icons as Record<string, unknown>)[category.icon]) as
    | React.ComponentType<{ size?: number; className?: string }>
    | undefined;

  return (
    <Link
      to={`/shop/${category.slug}`}
      className="group flex flex-col gap-3 rounded-card border border-night-blue/10 bg-white p-5 transition-all hover:border-leaf-green hover:shadow-md"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-leaf-green/10 text-leaf-green-ink">
        {Icon ? <Icon size={24} /> : <Icons.Leaf size={24} />}
      </div>
      <h3 className="font-condensed text-lg font-bold text-night-blue">
        {category.name}
      </h3>
      <p className="line-clamp-2 text-sm text-night-blue/70">
        {category.description}
      </p>
      <span className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-healthy-blue">
        Shop{" "}
        <ArrowRight
          size={14}
          className="transition-transform group-hover:translate-x-1"
        />
      </span>
    </Link>
  );
}
